import { render } from "./ParcelsList.vue?vue&type=template&id=9183b934&ts=true"
import script from "./ParcelsList.vue?vue&type=script&lang=ts"
export * from "./ParcelsList.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/apps/myparcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__